<template>
    <router-view></router-view>
</template>

<script>
export default {};
</script>
<style>
.md-select-menu {
    z-index: 9999 !important;
}

.sidebar-mini .main-panel {
    height: 100%;
}
</style>
